// 서버 함수 오류를 손님이 읽는 한국어 한 줄로 바꾼다 — 2026-10-28 대표 승인("응 승인할게"):
// 영어 오류 문구('Edge Function returned a non-2xx status code', 'Failed to send a request to the Edge Function') 대신 사유별 한국어 안내.
// supabase-js는 2xx가 아니면 FunctionsHttpError(context = 응답), 연결이 끊기면 FunctionsFetchError, 중계 실패면 FunctionsRelayError를 준다.
// 문장은 계정 연결 미리보기(InstagramConnectionFlow)가 이미 쓰던 안내와 같게 맞춘다.

type FunctionErrorLike = { name?: string; context?: unknown } | null | undefined;

const LOGIN_EXPIRED = '로그인이 만료되었어요. 다시 로그인해주세요.';
const TRY_LATER = '지금은 계정 정보를 불러올 수 없어요. 잠시 후 다시 시도해주세요.';

const statusOf = (error: FunctionErrorLike): number | null => {
    if (error?.name !== 'FunctionsHttpError') return null;
    const status = (error.context as { status?: unknown } | undefined)?.status;
    return typeof status === 'number' ? status : null;
};

// 서버가 손님용으로 써 둔 한국어 안내(예: 짧은 시간 조회 횟수 제한)를 읽는다 — 못 읽으면 null
const serverMessageOf = async (error: FunctionErrorLike): Promise<string | null> => {
    try {
        const body = await (error?.context as Response | undefined)?.clone().json();
        return typeof body?.message === 'string' && body.message ? body.message : null;
    } catch {
        return null;
    }
};

// 인스타그램 프로필 조회(visitor-analysis-target·instagram-profile) 실패 안내
export async function profileLookupErrorMessage(error: FunctionErrorLike, username?: string): Promise<string> {
    const status = statusOf(error);
    if (status === 400) return '아이디 형식이 올바르지 않아요. 영문·숫자·밑줄·마침표만 쓸 수 있어요.';
    if (status === 404) {
        return username
            ? `인스타그램에서 @${username} 계정을 찾을 수 없어요. 아이디를 다시 확인해주세요.`
            : '인스타그램에서 이 계정을 찾을 수 없어요. 아이디를 다시 확인해주세요.';
    }
    if (status === 401 || status === 403) return LOGIN_EXPIRED;
    if (status === 429) return (await serverMessageOf(error)) ?? TRY_LATER;
    // 409 = 내 인스타그램 계정을 먼저 등록해야 함, 422 = 자기 계정 분석(대표 11/3 — 서버도 같은 확인을 한다)
    if (status === 409 || status === 422) return (await serverMessageOf(error)) ?? TRY_LATER;
    return TRY_LATER;
}

// 그 밖의 서버 함수 실패 안내 — 로그인 만료만 따로 알리고, 나머지는 화면이 정해 둔 한국어 문장을 쓴다
export function functionErrorMessage(error: FunctionErrorLike, fallback: string): string {
    const status = statusOf(error);
    if (status === 401 || status === 403) return LOGIN_EXPIRED;
    return fallback;
}
